import { Question } from './question.js';

export class ThankYouMessageQuestion extends Question {
    isLastActiveThankYouMessage() {
        if (!this.ctx.questions) {
            return true;
        }
        let hasActiveAhead = false;
        for (let i = this.currentIndex + 1; i < this.ctx.questions.length; i++) {
            const q = this.ctx.questions[i];
            const props = q.properties ?? q;
            const type = props.type;
            const active = props.isActive;
            if (type === 'Thank You Message' && active !== '0' && active !== false) {
                hasActiveAhead = true;
                break;
            }
        }
        return !hasActiveAhead;
    }

    renderNextButton() {
        if (this.question.displayButton === false || this.question.displayButton === '0' || this.question.displayButton === 0) {
            return null;
        }

        if (this.ctx.surveyType === 'standalone' || this.ctx.surveyType === 'previewStandalone') {
            if (this.ctx.isRedirectedDirectlyToThankYou === true || this.isLastActiveThankYouMessage()) {
                return null;
            }
        }

        let nextButton = document.createElement('button');
        nextButton.classList.add('ph-btn--primary');
        nextButton.textContent = this.question.buttonName;
        nextButton.addEventListener('click', () => {
            this.ctx.trackBehavior(this.question, 'end');
            if (!this.ctx.isPreviewMode || this.ctx.surveyType === 'previewLink') {
                this.ctx.closeSurvey();
            }
        });
        return nextButton;
    }

    skipButtonElement() {
        if (this.question.customized === true || this.question.customized === 1 || this.question.customized === '1') {
            let skipButton = document.createElement('button');
            skipButton.id = 'skipButton' + this.question.id;
            
            if (this.question.displayButton === false || this.question.displayButton === '0' || this.question.displayButton === 0) {
                skipButton.classList.add('ph-btn--primary');
            } else {
                skipButton.classList.add('ph-btn--secondary');
            }

            skipButton.textContent = this.question.urlButtonName ? this.question.urlButtonName : 'Zu den Produkten';
            skipButton.addEventListener('click', () => {
                if (this.question.url) {
                    this.ctx.trackBehavior(this.question, 'custom_button_clicked');
                    if (this.question.openInNewTab) {
                        window.open(this.question.url, '_blank');
                        if (this.ctx.surveyType === 'standalone') {
                            this.ctx.closeSurvey();
                        }
                    } else {
                        window.location.href = this.question.url;
                        return;
                    }
                }
                
                if (!this.ctx.isPreviewMode || this.ctx.surveyType === 'previewLink') {
                    this.ctx.closeSurvey();
                }
            });
            return skipButton;
        }
        return null;
    }
}
